/* Selected Wallpapers — offerte-aanvraag (extern gemaakt 14-09-2026, was inline) */
(function(){
  // ── Vertalingen ────────────────────────────────────────────────────────────
  const T = {
    nl: {
      step1: 'Producten', step2: 'Contactgegevens', step3: 'Bevestiging',
      step1_label: 'Selecteer je producten en aantallen',
      add_product: 'Producten toevoegen',
      qty: 'Aantal', remove: 'Verwijder',
      contact_title: 'Contactgegevens',
      contact_intro: 'We hebben je gegevens nodig om een voorstel op maat te kunnen sturen.',
      first_name: 'Voornaam', last_name: 'Achternaam',
      email: 'E-mailadres', phone: 'Telefoon',
      address: 'Adres + huisnummer', postal: 'Postcode', city: 'Plaats',
      state: 'Provincie', country: 'Land', country_select: 'Selecteer…',
      billing_same: "Factuuradres is gelijk aan het bezorgadres", billing_title: "Factuuradres", billing_company: "Bedrijfsnaam (optioneel)",
      customer_notes: 'Opmerkingen', notes_placeholder: 'Vragen of wensen?',
      install_title: 'Installatie informatie (NL)',
      install_intro: 'Om een voorstel te maken voor het installeren van behang hebben wij de volgende informatie nodig:',
      install_disclaimer: 'Om het behang te installeren moeten de wanden sausklaar zijn opgeleverd, volledig glad. Indien dit niet het geval is, kunnen wij helaas niet installeren.',
      want_install: 'Wil je dat wij het behang ook installeren?',
      want_install_help: 'Kies "Nee" voor een prijsopgave zonder installatie.',
      wall_dimensions: 'Wandafmetingen',
      wall_label_prefix: 'Wand',
      wall_width: 'breedte (cm)',
      wall_height: 'hoogte (cm)',
      wall_add: '+ Wand toevoegen',
      wall_remove: 'Verwijder',
      wall_dimensions_help: 'Voer de exacte wandafmetingen in zonder marge, van plint tot plafond gemeten.',
      wall_already_primed: 'Is de wand reeds voorgestreken of gesausd?',
      wall_already_primed_help: 'Een wand dient na het stuken te worden voorgestreken met een transparante primer om de zuigende werking tegen te gaan.',
      wall_we_prime: 'Wil je dat wij de wanden voorstrijken?',
      yes: 'Ja', no: 'Nee',
      wall_help: '*Wij hebben wandafmetingen nodig voor de berekening en/of ondermaten.',
      photos: "Foto's wand(en) (max 4, 3 MB elk)",
      photos_install_help: 'Ter beoordeling hebben wij altijd een foto van de betreffende wand(en) nodig.',
      photos_required: 'Upload minimaal één foto van de wand(en).',
      verify_title: 'Controleer je aanvraag',
      submit: 'Verstuur aanvraag', back: 'Terug', next: 'Volgende stap',
      req: 'verplicht',
      success_title: 'Aanvraag ontvangen!',
      success_text: 'We hebben je aanvraag goed ontvangen en sturen je binnen 1-2 werkdagen een voorstel op maat.',
      error_required: 'Vul alle verplichte velden in',
      error_walls_required: 'Wandafmetingen zijn verplicht voor dit product. Vul breedte en hoogte in.',
      error_email: 'Ongeldig e-mailadres',
      error_photo_size: 'Foto te groot (max 3 MB)',
      error_submit: 'Er ging iets mis. Probeer opnieuw of mail ons direct.',
      error_sample: 'Je kan geen voorstel opvragen voor een sample. Selecteer eerst een variant zonder "Sample" in de naam.',
    },
    de: {
      step1: 'Produkte', step2: 'Kontaktdaten', step3: 'Bestätigung',
      step1_label: 'Wählen Sie Ihre Produkte und Mengen',
      add_product: 'Produkte hinzufügen',
      qty: 'Anzahl', remove: 'Entfernen',
      contact_title: 'Kontaktdaten',
      contact_intro: 'Wir benötigen Ihre Daten, um Ihnen einen individuellen Vorschlag zu senden.',
      first_name: 'Vorname', last_name: 'Nachname',
      email: 'E-Mail', phone: 'Telefon',
      address: 'Adresse + Hausnummer', postal: 'PLZ', city: 'Ort',
      state: 'Bundesland', country: 'Land', country_select: 'Auswählen…',
      billing_same: "Rechnungsadresse entspricht der Lieferadresse", billing_title: "Rechnungsadresse", billing_company: "Firmenname (optional)",
      customer_notes: 'Anmerkungen', notes_placeholder: 'Fragen oder Wünsche?',
      install_title: 'Installations-Informationen (NL)',
      install_intro: 'Für einen Installations-Vorschlag benötigen wir folgende Informationen:',
      install_disclaimer: 'Für die Tapezierung müssen die Wände streichfertig (vollständig glatt verputzt) sein. Andernfalls können wir leider nicht installieren.',
      want_install: 'Möchten Sie, dass wir die Tapete auch installieren?',
      want_install_help: 'Wählen Sie "Nein" für einen Vorschlag ohne Installation.',
      wall_dimensions: 'Wandmaße',
      wall_label_prefix: 'Wand',
      wall_width: 'Breite (cm)',
      wall_height: 'Höhe (cm)',
      wall_add: '+ Wand hinzufügen',
      wall_remove: 'Entfernen',
      wall_dimensions_help: 'Exakte Wandmaße ohne Reserve eingeben, von Sockel bis Decke gemessen.',
      wall_already_primed: 'Sind die Wände bereits grundiert oder gestrichen?',
      wall_already_primed_help: 'Wände sollten nach dem Verputzen mit einer transparenten Grundierung behandelt werden, um die saugende Wirkung zu reduzieren.',
      wall_we_prime: 'Sollen wir die Wände grundieren?',
      yes: 'Ja', no: 'Nein',
      wall_help: '*Wir benötigen die Wandmaße für die Berechnung und/oder für Untermaße.',
      photos: "Fotos der Wand(e) (max 4, je 3 MB)",
      photos_install_help: 'Für die Beurteilung benötigen wir immer ein Foto der betreffenden Wand(e).',
      photos_required: 'Bitte mindestens ein Foto der Wand(e) hochladen.',
      verify_title: 'Anfrage überprüfen',
      submit: 'Anfrage senden', back: 'Zurück', next: 'Weiter',
      req: 'erforderlich',
      success_title: 'Anfrage erhalten!',
      success_text: 'Wir haben Ihre Anfrage erhalten und senden Ihnen innerhalb von 1-2 Werktagen einen individuellen Vorschlag.',
      error_required: 'Bitte alle Pflichtfelder ausfüllen',
      error_walls_required: 'Wandmaße sind für dieses Produkt erforderlich. Bitte Breite und Höhe eingeben.',
      error_email: 'Ungültige E-Mail',
      error_photo_size: 'Foto zu groß (max 3 MB)',
      error_submit: 'Etwas ist schief gelaufen. Bitte erneut versuchen.',
      error_sample: 'Für ein Sample können Sie keinen Vorschlag anfordern. Bitte wählen Sie eine Variante ohne "Sample" im Namen.',
    },
    en: {
      step1: 'Products', step2: 'Contact details', step3: 'Confirmation',
      step1_label: 'Select your products and quantities',
      add_product: 'Add more products',
      qty: 'Quantity', remove: 'Remove',
      contact_title: 'Contact details',
      contact_intro: 'We need your details to send you a tailored proposal.',
      first_name: 'First name', last_name: 'Last name',
      email: 'Email', phone: 'Phone',
      address: 'Address + number', postal: 'Postal code', city: 'City',
      state: 'State', country: 'Country', country_select: 'Select…',
      billing_same: "Billing address is the same as the delivery address", billing_title: "Billing address", billing_company: "Company name (optional)",
      customer_notes: 'Notes', notes_placeholder: 'Questions or requests?',
      install_title: 'Installation information (NL)',
      install_intro: 'To make an installation proposal, we need the following information:',
      install_disclaimer: 'For installation the walls must be paint-ready, fully smooth-plastered. Otherwise we cannot install.',
      want_install: 'Would you like us to install the wallpaper as well?',
      want_install_help: 'Choose "No" for a price proposal only, without installation.',
      wall_dimensions: 'Wall dimensions',
      wall_label_prefix: 'Wall',
      wall_width: 'width (cm)',
      wall_height: 'height (cm)',
      wall_add: '+ Add wall',
      wall_remove: 'Remove',
      wall_dimensions_help: 'Enter exact wall dimensions without margin, measured from skirting to ceiling.',
      wall_already_primed: 'Have the walls been primed or painted?',
      wall_already_primed_help: 'After plastering, walls need to be primed with a transparent primer to reduce absorbency.',
      wall_we_prime: 'Do you want us to prime the walls?',
      yes: 'Yes', no: 'No',
      wall_help: '*We need wall dimensions for calculations and/or trim allowances.',
      photos: 'Wall photos (max 4, 3 MB each)',
      photos_install_help: 'For evaluation we always need a photo of the wall(s).',
      photos_required: 'Please upload at least one photo of the wall(s).',
      verify_title: 'Review your request',
      submit: 'Send request', back: 'Back', next: 'Next step',
      req: 'required',
      success_title: 'Request received!',
      success_text: 'We received your proposal request and will send you a tailored proposal within 1-2 business days.',
      success_text_us: 'Thank you. You will usually receive your price in USD by email within the hour, with shipping, duties and taxes included.',
      error_required: 'Please fill in all required fields',
      error_walls_required: 'Wall dimensions are required for this product. Please enter width and height.',
      error_email: 'Invalid email',
      error_photo_size: 'Photo too large (max 3 MB)',
      error_submit: 'Something went wrong. Please try again or email us.',
      error_sample: 'You cannot request a proposal for a sample. Please select a variant without "Sample" in the name.',
    },
    fr: {
      step1: 'Produits', step2: 'Coordonnées', step3: 'Confirmation',
      step1_label: 'Sélectionnez vos produits et quantités',
      add_product: 'Ajouter des produits',
      qty: 'Quantité', remove: 'Supprimer',
      contact_title: 'Coordonnées',
      contact_intro: 'Nous avons besoin de vos coordonnées pour vous envoyer une proposition sur mesure.',
      first_name: 'Prénom', last_name: 'Nom',
      email: 'E-mail', phone: 'Téléphone',
      address: 'Adresse + numéro', postal: 'Code postal', city: 'Ville',
      state: 'Région', country: 'Pays', country_select: 'Sélectionnez…',
      billing_same: "L’adresse de facturation est identique à l’adresse de livraison", billing_title: "Adresse de facturation", billing_company: "Nom de l’entreprise (facultatif)",
      customer_notes: 'Remarques', notes_placeholder: 'Questions ou souhaits ?',
      install_title: 'Informations de pose (NL)',
      install_intro: 'Pour établir une proposition de pose du papier peint, nous avons besoin des informations suivantes :',
      install_disclaimer: 'Pour poser le papier peint, les murs doivent être livrés prêts à peindre, parfaitement lisses. Dans le cas contraire, nous ne pourrons malheureusement pas effectuer la pose.',
      want_install: 'Souhaitez-vous que nous posions également le papier peint ?',
      want_install_help: 'Choisissez « Non » pour un devis sans pose.',
      wall_dimensions: 'Dimensions des murs',
      wall_label_prefix: 'Mur',
      wall_width: 'largeur (cm)',
      wall_height: 'hauteur (cm)',
      wall_add: '+ Ajouter un mur',
      wall_remove: 'Supprimer',
      wall_dimensions_help: 'Saisissez les dimensions exactes des murs sans marge, mesurées de la plinthe au plafond.',
      wall_already_primed: 'Le mur est-il déjà sous-couché ou peint ?',
      wall_already_primed_help: 'Après l’enduisage, un mur doit être traité avec une sous-couche transparente pour réduire son pouvoir absorbant.',
      wall_we_prime: 'Souhaitez-vous que nous appliquions la sous-couche sur les murs ?',
      yes: 'Oui', no: 'Non',
      wall_help: '*Nous avons besoin des dimensions des murs pour le calcul et/ou les sous-mesures.',
      photos: 'Photos du/des mur(s) (max. 4, 3 Mo chacune)',
      photos_install_help: 'Pour l’évaluation, nous avons toujours besoin d’une photo du/des mur(s) concerné(s).',
      photos_required: 'Veuillez télécharger au moins une photo du/des mur(s).',
      verify_title: 'Vérifiez votre demande',
      submit: 'Envoyer la demande', back: 'Retour', next: 'Étape suivante',
      req: 'obligatoire',
      success_title: 'Demande reçue !',
      success_text: 'Nous avons bien reçu votre demande et vous enverrons une proposition sur mesure sous 1 à 2 jours ouvrés.',
      error_required: 'Veuillez remplir tous les champs obligatoires',
      error_walls_required: 'Les dimensions des murs sont obligatoires pour ce produit. Veuillez saisir la largeur et la hauteur.',
      error_email: 'Adresse e-mail invalide',
      error_photo_size: 'Photo trop volumineuse (max. 3 Mo)',
      error_submit: 'Une erreur s’est produite. Veuillez réessayer ou nous écrire directement.',
      error_sample: 'Vous ne pouvez pas demander de proposition pour un échantillon. Sélectionnez d’abord une variante sans « Échantillon » dans le nom.',
    },
    it: {
      step1: 'Prodotti', step2: 'Dati di contatto', step3: 'Conferma',
      step1_label: 'Seleziona i tuoi prodotti e le quantità',
      add_product: 'Aggiungi prodotti',
      qty: 'Quantità', remove: 'Rimuovi',
      contact_title: 'Dati di contatto',
      contact_intro: 'Abbiamo bisogno dei vostri dati per inviarvi una proposta su misura.',
      first_name: 'Nome', last_name: 'Cognome',
      email: 'E-mail', phone: 'Telefono',
      address: 'Indirizzo + numero civico', postal: 'CAP', city: 'Città',
      state: 'Provincia', country: 'Paese', country_select: 'Seleziona…',
      billing_same: "L’indirizzo di fatturazione è uguale a quello di consegna", billing_title: "Indirizzo di fatturazione", billing_company: "Ragione sociale (facoltativo)",
      customer_notes: 'Note', notes_placeholder: 'Domande o richieste?',
      install_title: 'Informazioni di posa (NL)',
      install_intro: 'Per preparare una proposta per la posa della carta da parati abbiamo bisogno delle seguenti informazioni:',
      install_disclaimer: 'Per posare la carta da parati le pareti devono essere consegnate pronte alla pittura, perfettamente lisce. In caso contrario non possiamo purtroppo effettuare la posa.',
      want_install: 'Desiderate che posiamo anche la carta da parati?',
      want_install_help: 'Scegliete « No » per un preventivo senza posa.',
      wall_dimensions: 'Dimensioni delle pareti',
      wall_label_prefix: 'Parete',
      wall_width: 'larghezza (cm)',
      wall_height: 'altezza (cm)',
      wall_add: '+ Aggiungi parete',
      wall_remove: 'Rimuovi',
      wall_dimensions_help: 'Inserite le dimensioni esatte delle pareti senza margine, misurate dal battiscopa al soffitto.',
      wall_already_primed: 'La parete è già stata trattata con primer o tinteggiata?',
      wall_already_primed_help: 'Dopo la rasatura una parete va trattata con un primer trasparente per ridurne il potere assorbente.',
      wall_we_prime: 'Desiderate che applichiamo il primer sulle pareti?',
      yes: 'Sì', no: 'No',
      wall_help: '*Ci servono le dimensioni delle pareti per il calcolo e/o per le sottomisure.',
      photos: 'Foto della/e parete/i (max 4, 3 MB ciascuna)',
      photos_install_help: 'Per la valutazione ci serve sempre una foto della/e parete/i interessata/e.',
      photos_required: 'Caricate almeno una foto della/e parete/i.',
      verify_title: 'Controllate la vostra richiesta',
      submit: 'Invia la richiesta', back: 'Indietro', next: 'Passo successivo',
      req: 'obbligatorio',
      success_title: 'Richiesta ricevuta!',
      success_text: 'Abbiamo ricevuto la vostra richiesta e vi invieremo una proposta su misura entro 1-2 giorni lavorativi.',
      error_required: 'Compilate tutti i campi obbligatori',
      error_walls_required: 'Le dimensioni delle pareti sono obbligatorie per questo prodotto. Inserite larghezza e altezza.',
      error_email: 'Indirizzo e-mail non valido',
      error_photo_size: 'Foto troppo grande (max 3 MB)',
      error_submit: 'Si è verificato un errore. Riprovate o scriveteci direttamente.',
      error_sample: 'Non potete richiedere una proposta per un campione. Selezionate prima una variante senza « Campione » nel nome.',
    },
    es: {
      step1: 'Productos', step2: 'Datos de contacto', step3: 'Confirmación',
      step1_label: 'Selecciona tus productos y cantidades',
      add_product: 'Añadir productos',
      qty: 'Cantidad', remove: 'Eliminar',
      contact_title: 'Datos de contacto',
      contact_intro: 'Necesitamos tus datos para enviarte una propuesta a medida.',
      first_name: 'Nombre', last_name: 'Apellidos',
      email: 'Correo electrónico', phone: 'Teléfono',
      address: 'Dirección + número', postal: 'Código postal', city: 'Ciudad',
      state: 'Provincia', country: 'País', country_select: 'Selecciona…',
      billing_same: "La dirección de facturación es la misma que la de entrega", billing_title: "Dirección de facturación", billing_company: "Nombre de la empresa (opcional)",
      customer_notes: 'Notas', notes_placeholder: '¿Preguntas o peticiones?',
      install_title: 'Información de instalación (NL)',
      install_intro: 'Para preparar una propuesta para la instalación del papel pintado necesitamos la siguiente información:',
      install_disclaimer: 'Para instalar el papel pintado, las paredes deben entregarse listas para pintar, perfectamente lisas. De lo contrario no podemos realizar la instalación.',
      want_install: '¿Quieres que instalemos también el papel pintado?',
      want_install_help: 'Elige « No » para un presupuesto sin instalación.',
      wall_dimensions: 'Dimensiones de las paredes',
      wall_label_prefix: 'Pared',
      wall_width: 'ancho (cm)',
      wall_height: 'alto (cm)',
      wall_add: '+ Añadir pared',
      wall_remove: 'Eliminar',
      wall_dimensions_help: 'Introduce las dimensiones exactas de las paredes sin margen, medidas del rodapié al techo.',
      wall_already_primed: '¿La pared ya está tratada con imprimación o pintada?',
      wall_already_primed_help: 'Tras el alisado, una pared debe tratarse con una imprimación transparente para reducir su poder de absorción.',
      wall_we_prime: '¿Quieres que apliquemos la imprimación en las paredes?',
      yes: 'Sí', no: 'No',
      wall_help: '*Necesitamos las dimensiones de las paredes para el cálculo y/o las submedidas.',
      photos: 'Fotos de la(s) pared(es) (máx. 4, 3 MB cada una)',
      photos_install_help: 'Para la evaluación siempre necesitamos una foto de la(s) pared(es) en cuestión.',
      photos_required: 'Sube al menos una foto de la(s) pared(es).',
      verify_title: 'Revisa tu solicitud',
      submit: 'Enviar la solicitud', back: 'Atrás', next: 'Paso siguiente',
      req: 'obligatorio',
      success_title: '¡Solicitud recibida!',
      success_text: 'Hemos recibido tu solicitud y te enviaremos una propuesta a medida en un plazo de 1-2 días laborables.',
      error_required: 'Rellena todos los campos obligatorios',
      error_walls_required: 'Las dimensiones de las paredes son obligatorias para este producto. Introduce ancho y alto.',
      error_email: 'Dirección de correo electrónico no válida',
      error_photo_size: 'Foto demasiado grande (máx. 3 MB)',
      error_submit: 'Se ha producido un error. Inténtalo de nuevo o escríbenos directamente.',
      error_sample: 'No puedes solicitar una propuesta para una muestra. Selecciona primero una variante sin « Muestra » en el nombre.',
    },
  };

  // Volledige country-lijst per locale (alfabetisch, NL/BE/DE bovenaan voor NL,
  // DE/AT/CH voor DE, populairste markten voor EN bovenaan).
  const COUNTRIES_NL = [
    ['NL','Nederland'],['BE','België'],['DE','Duitsland'],['LU','Luxemburg'],['FR','Frankrijk'],['GB','Verenigd Koninkrijk'],['__sep','──────────'],
    ['AT','Oostenrijk'],['CH','Zwitserland'],['DK','Denemarken'],['ES','Spanje'],['FI','Finland'],['IE','Ierland'],['IT','Italië'],['NO','Noorwegen'],['PL','Polen'],['PT','Portugal'],['SE','Zweden'],['CZ','Tsjechië'],['HU','Hongarije'],['GR','Griekenland'],['RO','Roemenië'],['BG','Bulgarije'],['HR','Kroatië'],['SK','Slowakije'],['SI','Slovenië'],['EE','Estland'],['LV','Letland'],['LT','Litouwen'],['IS','IJsland'],['MT','Malta'],['CY','Cyprus'],['__sep2','──────────'],
    ['US','Verenigde Staten'],['CA','Canada'],['AU','Australië'],['NZ','Nieuw-Zeeland'],['JP','Japan'],['SG','Singapore'],['HK','Hongkong'],['AE','Verenigde Arabische Emiraten'],['IL','Israël'],['TR','Turkije'],['ZA','Zuid-Afrika'],['BR','Brazilië'],['MX','Mexico']
  ];
  const COUNTRIES_DE = [
    ['DE','Deutschland'],['AT','Österreich'],['CH','Schweiz'],['LU','Luxemburg'],['NL','Niederlande'],['BE','Belgien'],['__sep','──────────'],
    ['DK','Dänemark'],['ES','Spanien'],['FI','Finnland'],['FR','Frankreich'],['GB','Vereinigtes Königreich'],['IE','Irland'],['IT','Italien'],['NO','Norwegen'],['PL','Polen'],['PT','Portugal'],['SE','Schweden'],['CZ','Tschechien'],['HU','Ungarn'],['GR','Griechenland'],['RO','Rumänien'],['BG','Bulgarien'],['HR','Kroatien'],['SK','Slowakei'],['SI','Slowenien'],['EE','Estland'],['LV','Lettland'],['LT','Litauen'],['IS','Island'],['MT','Malta'],['CY','Zypern'],['__sep2','──────────'],
    ['US','Vereinigte Staaten'],['CA','Kanada'],['AU','Australien'],['NZ','Neuseeland'],['JP','Japan'],['SG','Singapur'],['HK','Hongkong'],['AE','Vereinigte Arabische Emirate'],['IL','Israel'],['TR','Türkei'],['ZA','Südafrika'],['BR','Brasilien'],['MX','Mexiko']
  ];
  const COUNTRIES_EN = [
    ['GB','United Kingdom'],['IE','Ireland'],['US','United States'],['CA','Canada'],['AU','Australia'],['NZ','New Zealand'],['__sep','──────────'],
    ['AT','Austria'],['BE','Belgium'],['BG','Bulgaria'],['HR','Croatia'],['CY','Cyprus'],['CZ','Czech Republic'],['DK','Denmark'],['EE','Estonia'],['FI','Finland'],['FR','France'],['DE','Germany'],['GR','Greece'],['HU','Hungary'],['IS','Iceland'],['IT','Italy'],['LV','Latvia'],['LT','Lithuania'],['LU','Luxembourg'],['MT','Malta'],['NL','Netherlands'],['NO','Norway'],['PL','Poland'],['PT','Portugal'],['RO','Romania'],['SK','Slovakia'],['SI','Slovenia'],['ES','Spain'],['SE','Sweden'],['CH','Switzerland'],['__sep2','──────────'],
    ['JP','Japan'],['SG','Singapore'],['HK','Hong Kong'],['AE','United Arab Emirates'],['IL','Israel'],['TR','Turkey'],['ZA','South Africa'],['BR','Brazil'],['MX','Mexico']
  ];
  const COUNTRIES_FR = [
    ['FR','France'],['BE','Belgique'],['LU','Luxembourg'],['CH','Suisse'],['NL','Pays-Bas'],['GB','Royaume-Uni'],['__sep','──────────'],
    ['DE','Allemagne'],['AT','Autriche'],['DK','Danemark'],['ES','Espagne'],['FI','Finlande'],['IE','Irlande'],['IT','Italie'],['NO','Norvège'],['PL','Pologne'],['PT','Portugal'],['SE','Suède'],['CZ','Tchéquie'],['HU','Hongrie'],['GR','Grèce'],['RO','Roumanie'],['BG','Bulgarie'],['HR','Croatie'],['SK','Slovaquie'],['SI','Slovénie'],['EE','Estonie'],['LV','Lettonie'],['LT','Lituanie'],['IS','Islande'],['MT','Malte'],['CY','Chypre'],['__sep2','──────────'],
    ['US','États-Unis'],['CA','Canada'],['AU','Australie'],['NZ','Nouvelle-Zélande'],['JP','Japon'],['SG','Singapour'],['HK','Hong Kong'],['AE','Émirats arabes unis'],['IL','Israël'],['TR','Turquie'],['ZA','Afrique du Sud'],['BR','Brésil'],['MX','Mexique']
  ];
  const COUNTRIES_IT = [
    ['IT','Italia'],['CH','Svizzera'],['SM','San Marino'],['FR','Francia'],['DE','Germania'],['GB','Regno Unito'],['__sep','──────────'],
    ['AT','Austria'],['BE','Belgio'],['NL','Paesi Bassi'],['LU','Lussemburgo'],['IE','Irlanda'],['ES','Spagna'],['PT','Portogallo'],['DK','Danimarca'],['FI','Finlandia'],['NO','Norvegia'],['SE','Svezia'],['PL','Polonia'],['CZ','Repubblica Ceca'],['HU','Ungheria'],['GR','Grecia'],['RO','Romania'],['BG','Bulgaria'],['HR','Croazia'],['SK','Slovacchia'],['SI','Slovenia'],['EE','Estonia'],['LV','Lettonia'],['LT','Lituania'],['IS','Islanda'],['MT','Malta'],['CY','Cipro'],['__sep2','──────────'],
    ['US','Stati Uniti'],['CA','Canada'],['AU','Australia'],['NZ','Nuova Zelanda'],['JP','Giappone'],['SG','Singapore'],['HK','Hong Kong'],['AE','Emirati Arabi Uniti'],['IL','Israele'],['TR','Turchia'],['ZA','Sudafrica'],['BR','Brasile'],['MX','Messico']
  ];
  const COUNTRIES_ES = [
    ['ES','España'],['PT','Portugal'],['FR','Francia'],['AD','Andorra'],['GI','Gibraltar'],['__sep','──────────'],
    ['DE','Alemania'],['GB','Reino Unido'],['IT','Italia'],['BE','Bélgica'],['NL','Países Bajos'],['LU','Luxemburgo'],['IE','Irlanda'],['AT','Austria'],['CH','Suiza'],['DK','Dinamarca'],['FI','Finlandia'],['NO','Noruega'],['SE','Suecia'],['PL','Polonia'],['CZ','Chequia'],['HU','Hungría'],['GR','Grecia'],['RO','Rumanía'],['BG','Bulgaria'],['HR','Croacia'],['SK','Eslovaquia'],['SI','Eslovenia'],['EE','Estonia'],['LV','Letonia'],['LT','Lituania'],['IS','Islandia'],['MT','Malta'],['CY','Chipre'],['__sep2','──────────'],
    ['US','Estados Unidos'],['CA','Canadá'],['MX','México'],['AU','Australia'],['NZ','Nueva Zelanda'],['JP','Japón'],['SG','Singapur'],['HK','Hong Kong'],['AE','Emiratos Árabes Unidos'],['IL','Israel'],['TR','Turquía'],['ZA','Sudáfrica'],['BR','Brasil']
  ];
  const COUNTRIES = { nl: COUNTRIES_NL, de: COUNTRIES_DE, en: COUNTRIES_EN, fr: COUNTRIES_FR, it: COUNTRIES_IT, es: COUNTRIES_ES };
  // States/provinces alleen verplicht voor deze landen
  const STATE_REQUIRED_COUNTRIES = ['US','CA','AU'];

  const SW = window.SWQuote = {
    STORAGE: 'sw_quote_v1',
    DASHBOARD: 'https://dashboard.selectedwallpapers.com/v3/api/quotes/submit',
    products: [],
    photos: [],
    step: 1,
    contact: {},
    install: {},
    locale: 'nl',
    t(k){ return T[this.locale][k] || T.nl[k] || k; },

    _dbg(step, extra) {
      try {
        fetch('https://dashboard.selectedwallpapers.com/api/proxy/upsell/event', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({event: 'sw-quote-debug', surface: 'quote-modal', glue_key: step, details: extra || {}}),
        }).catch(()=>{});
      } catch(_e) {}
    },

    init() {
      try {
        const wrap = document.querySelector('.sw-quote-wrap');
        this._dbg('init:start', {hasWrap: !!wrap});
        if (!wrap) { this._dbg('init:no-wrap'); return; }
        this.locale = wrap.dataset.locale || 'nl';
        if (!T[this.locale]) this.locale = 'nl';
        this._dbg('init:locale', {locale: this.locale, hasDataset: !!wrap.dataset.currentProduct});
        this.currentProduct = JSON.parse(wrap.dataset.currentProduct);
        this._dbg('init:parsed', {pid: this.currentProduct.product_id, variants: this.currentProduct.variants && this.currentProduct.variants.length});
        this.loadStorage();
        // Kevin 19-10-2026: cm/inch zoals de calculator. Keuze alleen op /en; /en-us altijd inch; overige talen cm.
        this.unitToggle = wrap.dataset.unitToggle === 'true';
        const unitStart = wrap.dataset.unit === 'in' ? 'in' : 'cm';
        if (!this.unitToggle || (this.install.unit !== 'in' && this.install.unit !== 'cm')) this.install.unit = unitStart;

        // Verplaats modal naar <body> om CSS stacking-context-issues te voorkomen
        const modal = document.getElementById('sw-quote-modal');
        if (modal && modal.parentElement !== document.body) {
          document.body.appendChild(modal);
        }
        this._dbg('init:done');
      } catch(e) {
        const wrap = document.querySelector('.sw-quote-wrap');
        const dataPreview = wrap ? (wrap.dataset.currentProduct||'').slice(0, 300) : '';
        const around51 = wrap ? (wrap.dataset.currentProduct||'').slice(40, 80) : '';
        this._dbg('init:EXCEPTION', {
          msg: String(e).slice(0,300),
          url: window.location.pathname,
          dataLen: dataPreview.length,
          preview: dataPreview.slice(0, 150),
          around51: around51,
        });
      }
    },

    loadStorage() {
      try {
        const raw = sessionStorage.getItem(this.STORAGE);
        if (raw) {
          const data = JSON.parse(raw);
          this.products = data.products || [];
          this.contact = data.contact || {};
          this.install = data.install || {};
        }
      } catch(e) { this.products = []; }
    },
    saveStorage() {
      try {
        sessionStorage.setItem(this.STORAGE, JSON.stringify({
          products: this.products, contact: this.contact, install: this.install,
        }));
      } catch(e) {}
    },

    open() {
      // Kevin 08-10-2026: op /en-us/ staat United States al gekozen (sneller invullen)
      try {
        if (String((window.Shopify && window.Shopify.country) || '').toUpperCase() === 'US' && !(this.contact && this.contact.country)) {
          this.contact = Object.assign({}, this.contact || {}, { country: 'US' });
        }
      } catch (e) {}
      try {
      this._dbg('open:start', {hasProduct: !!this.currentProduct});
      this._preloadConsent();
      const cp = this.currentProduct;
      if (!cp) { this._dbg('open:NO-PRODUCT'); return; }
      // Detecteer geselecteerde variant uit URL (?variant=X) of fallback naar
      // eerste beschikbare niet-sample variant
      const urlParams = new URLSearchParams(window.location.search);
      const selectedId = parseInt(urlParams.get('variant')) || null;
      let variant = selectedId ? cp.variants.find(v => v.id === selectedId) : null;
      if (!variant) variant = cp.variants.find(v => v.available && !v.is_sample) || cp.variants[0];

      // Sample-blokkade: niet toevoegen, foutbericht tonen
      this.sampleError = null;
      if (variant && variant.is_sample) {
        this.sampleError = this.t('error_sample');
      } else if (variant) {
        // Niet dubbel toevoegen
        if (!this.products.find(p => p.variant_id === variant.id)) {
          this.products.push({
            product_id: cp.product_id,
            title: cp.title,
            vendor: cp.vendor,
            image: cp.image,
            requires_wall: cp.requires_wall,
            variant_id: variant.id,
            variant_title: variant.title,
            sku: variant.sku,
            qty: 1,
            original_price: variant.price,
            currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '',   // presentment-valuta van de markt waarin dit product is toegevoegd
          });
          this.saveStorage();
        }
      }
      this.step = 1;
      this.render();
      const m = document.getElementById('sw-quote-modal');
      this._dbg('open:show', {hasModal: !!m});
      if (m) { m.hidden = false; }
      document.body.style.overflow = 'hidden';
      } catch(e) {
        this._dbg('open:EXCEPTION', {msg: String(e).slice(0,300)});
      }
    },
    close() {
      document.getElementById('sw-quote-modal').hidden = true;
      document.body.style.overflow = '';
    },

    render() {
      this.renderSteps();
      this.renderBody();
      this.renderFooter();
    },

    renderSteps() {
      const labels = [this.t('step1'), this.t('step2'), this.t('step3')];
      document.getElementById('sw-steps').innerHTML = labels.map((l,i) => `
        <div class="sw-step ${this.step >= i+1 ? 'active':''}">
          <div class="num">${({nl:'STAP',de:'SCHRITT',en:'STEP',fr:'ÉTAPE',it:'PASSO',es:'PASO'}[this.locale]||'STAP')} ${i+1}</div>
          <div class="label">${l}</div>
        </div>`).join('');
    },

    renderBody() {
      const body = document.getElementById('sw-body');
      if (this.step === 1) body.innerHTML = this.renderStep1();
      else if (this.step === 2) body.innerHTML = this.renderStep2();
      else if (this.step === 3) body.innerHTML = this.renderStep3();
      else if (this.step === 4) body.innerHTML = this.renderSuccess();
      this.bindBody();
    },

    renderStep1() {
      const productsHtml = this.products.map(p => `
        <div class="sw-product-card" data-vid="${p.variant_id}">
          ${p.image ? `<img src="${p.image}" alt="">` : '<div style="width:64px;height:64px;background:#f0f0f0;border-radius:4px"></div>'}
          <div class="info">
            <div class="name">${this.esc(p.title)}</div>
            <div class="variant">${this.esc(p.variant_title || '')} ${p.sku ? '· '+this.esc(p.sku) : ''}</div>
            <input type="number" class="qty" min="1" max="999" value="${p.qty}" data-action="qty">
            <span style="color:#666;font-size:12px;margin-left:6px">${this.t('qty')}</span>
          </div>
          <button class="sw-product-remove" data-action="remove" title="${this.t('remove')}">×</button>
        </div>`).join('');
      const sampleErr = this.sampleError ? `
        <div style="background:#fff5f5;border:1px solid #fcc;color:#c00;padding:12px 14px;border-radius:5px;font-size:13px;margin-bottom:14px;line-height:1.4">
          ${this.esc(this.sampleError)}
        </div>` : '';
      const emptyMsg = !this.products.length && !this.sampleError ? `
        <div style="background:#f8f8f8;color:#666;padding:14px;border-radius:5px;font-size:13px;margin-bottom:14px">
          ${this.locale === 'de' ? 'Noch keine Produkte hinzugefügt. Wählen Sie eine Variante ohne "Sample" und klicken erneut.'
          : this.locale === 'en' ? 'No products added yet. Select a non-sample variant and click again.'
          : this.locale === 'fr' ? 'Aucun produit ajouté pour le moment. Sélectionnez une variante hors échantillon et cliquez à nouveau.'
          : 'Nog geen producten toegevoegd. Kies een variant zonder "Sample" en klik opnieuw.'}
        </div>` : '';
      return `
        ${sampleErr}
        <p style="color:#666;margin:0 0 14px;font-size:14px">${this.t('step1_label')}</p>
        ${emptyMsg}
        ${productsHtml}
        <button class="sw-quote-btn text" onclick="window.SWQuote.addAnotherProduct()">+ ${this.t('add_product')}</button>
      `;
    },

    renderStep2() {
      const c = this.contact;
      const showInstall = this.locale === 'nl';
      const wantInstall = showInstall && this.install.want_install === 'yes';
      const requiresWall = this.products.some(p => p.requires_wall);
      const i = this.install;
      const countries = COUNTRIES[this.locale] || COUNTRIES.en;
      return `
        <h3 style="margin:0 0 6px;font-size:18px">${this.t('contact_title')}</h3>
        <p style="color:#666;margin:0 0 18px;font-size:14px">${this.t('contact_intro')}</p>

        <div class="sw-quote-row">
          <div class="sw-quote-field"><label>${this.t('first_name')} <span class="req">*</span></label>
            <input data-field="first_name" value="${this.esc(c.first_name||'')}"></div>
          <div class="sw-quote-field"><label>${this.t('last_name')} <span class="req">*</span></label>
            <input data-field="last_name" value="${this.esc(c.last_name||'')}"></div>
        </div>
        <div class="sw-quote-row">
          <div class="sw-quote-field"><label>${this.t('email')} <span class="req">*</span></label>
            <input data-field="email" type="email" value="${this.esc(c.email||'')}"></div>
          <div class="sw-quote-field"><label>${this.t('phone')} <span class="req">*</span></label>
            <input data-field="phone" type="tel" value="${this.esc(c.phone||'')}"></div>
        </div>
        <div class="sw-quote-row full">
          <div class="sw-quote-field"><label>${this.t('address')} <span class="req">*</span></label>
            <input data-field="address" value="${this.esc(c.address||'')}"></div>
        </div>
        <div class="sw-quote-row">
          <div class="sw-quote-field"><label>${this.t('postal')} <span class="req">*</span></label>
            <input data-field="postal" value="${this.esc(c.postal||'')}"></div>
          <div class="sw-quote-field"><label>${this.t('city')} <span class="req">*</span></label>
            <input data-field="city" value="${this.esc(c.city||'')}"></div>
        </div>
        <div class="sw-quote-row">
          <div class="sw-quote-field">
            <label>${this.t('state')} <span class="req" id="sw-state-req-mark" style="display:none">*</span></label>
            <input data-field="state" value="${this.esc(c.state||'')}">
          </div>
          <div class="sw-quote-field"><label>${this.t('country')} <span class="req">*</span></label>
            <select data-field="country">
              <option value="">${this.t('country_select')}</option>
              ${countries.map(([code,name]) => code.startsWith('__')
                ? `<option disabled>${name}</option>`
                : `<option value="${code}" ${c.country===code?'selected':''}>${name}</option>`).join('')}
            </select></div>
        </div>
        <div class="sw-quote-row full">
          <label style="display:flex;align-items:center;gap:8px;font-size:14px;cursor:pointer;margin:2px 0 6px">
            <input type="checkbox" id="sw-bill-same" ${c.bill_different ? '' : 'checked'} style="width:auto;margin:0">
            <span>${this.t('billing_same')}</span>
          </label>
        </div>
        ${c.bill_different ? this.renderBilling() : ''}
        <div class="sw-quote-row full">
          <div class="sw-quote-field"><label>${this.t('customer_notes')}</label>
            <textarea data-field="customer_notes" rows="3" placeholder="${this.t('notes_placeholder')}">${this.esc(c.customer_notes||'')}</textarea></div>
        </div>

        ${(requiresWall || wantInstall) ? `
        <h3 style="margin:18px 0 6px;font-size:15px;border-top:1px solid #eee;padding-top:14px">
          ${this.t('wall_dimensions')} <span class="req">*</span>
        </h3>
        <div class="sw-quote-row full">
          <div class="sw-quote-field">
            ${this.renderUnitToggle()}
            <div id="sw-walls-list">${this.renderWallsList()}</div>
            <button type="button" class="sw-wall-add" id="sw-wall-add">${this.t('wall_add')}</button>
            <div class="sw-quote-help">${this.t('wall_dimensions_help')}</div>
          </div>
        </div>
        ` : ''}

        ${showInstall ? `
        <h3 style="margin:18px 0 4px;font-size:15px;border-top:1px solid #eee;padding-top:14px">${this.t('install_title')}</h3>
        <div class="sw-quote-row full">
          <div class="sw-quote-field">
            <label>${this.t('want_install')} <span class="req">*</span>
              <span class="sw-tooltip" data-tip="${this.esc(this.t('want_install_help'))}">?</span>
            </label>
            <div class="sw-radio-group">
              <label class="sw-radio">
                <input type="radio" name="want_install" value="yes" data-install="want_install" ${i.want_install==='yes'?'checked':''}>
                <span>${this.t('yes')}</span>
              </label>
              <label class="sw-radio">
                <input type="radio" name="want_install" value="no" data-install="want_install" ${i.want_install==='no'?'checked':''}>
                <span>${this.t('no')}</span>
              </label>
            </div>
          </div>
        </div>
        ${wantInstall ? `<p style="color:#666;margin:6px 0 12px;font-size:13px;line-height:1.5">${this.t('install_intro')}</p>` : ''}
        ` : ''}

        ${wantInstall ? `
        <div style="background:#fff8ec;border:1px solid #f5c75d;color:#7c5b00;padding:12px 14px;border-radius:5px;font-size:12.5px;line-height:1.5;margin-bottom:14px">
          <strong>${({nl:'Let op',de:'Hinweis',en:'Note',fr:'Attention',it:'Attenzione',es:'Atención'}[this.locale]||'Let op')}:</strong> ${this.t('install_disclaimer')}
        </div>
        <div class="sw-quote-row sw-quote-row-stack">
          <div class="sw-quote-field">
            <label>${this.t('wall_already_primed')} <span class="req" id="sw-primed-req">*</span>
              <span class="sw-tooltip" data-tip="${this.esc(this.t('wall_already_primed_help'))}">?</span>
            </label>
            <div class="sw-radio-group">
              <label class="sw-radio">
                <input type="radio" name="wall_already_primed" value="yes" data-install="wall_already_primed" ${i.wall_already_primed==='yes'?'checked':''}>
                <span>${this.t('yes')}</span>
              </label>
              <label class="sw-radio">
                <input type="radio" name="wall_already_primed" value="no" data-install="wall_already_primed" ${i.wall_already_primed==='no'?'checked':''}>
                <span>${this.t('no')}</span>
              </label>
            </div>
          </div>
          <div class="sw-quote-field">
            <label>${this.t('wall_we_prime')} <span class="req" id="sw-weprime-req">*</span></label>
            <div class="sw-radio-group">
              <label class="sw-radio">
                <input type="radio" name="wall_we_prime" value="yes" data-install="wall_we_prime" ${i.wall_we_prime==='yes'?'checked':''}>
                <span>${this.t('yes')}</span>
              </label>
              <label class="sw-radio">
                <input type="radio" name="wall_we_prime" value="no" data-install="wall_we_prime" ${i.wall_we_prime==='no'?'checked':''}>
                <span>${this.t('no')}</span>
              </label>
            </div>
          </div>
        </div>
        <div class="sw-quote-row full">
          <div class="sw-quote-field">
            <label>${this.t('photos')} <span class="req" id="sw-photos-req-mark">*</span></label>
            <div class="sw-photo-upload" id="sw-photos">${this.renderPhotos()}</div>
            <div class="sw-quote-help" style="margin-top:8px">${this.t('photos_install_help')}</div>
          </div>
        </div>` : ''}

        <div id="sw-step2-error" class="sw-error" hidden></div>
      `;
    },

    renderPhotos() {
      const slots = [0,1,2,3].map(i => {
        const p = this.photos[i];
        if (p) {
          return `<div class="sw-photo-thumb">
            <img src="${p.preview}" alt="">
            <button class="sw-photo-remove" data-photo-idx="${i}">×</button>
          </div>`;
        }
        return `<div class="sw-photo-thumb">
          <span>+</span>
          <input type="file" accept="image/*" data-photo-slot="${i}">
        </div>`;
      });
      return slots.join('');
    },

    // Kevin 22-10-2026: apart factuuradres met één vinkje (standaard gelijk aan het bezorgadres)
    renderBilling() {
      const b = this.contact.billing || {};
      const countries = COUNTRIES[this.locale] || COUNTRIES.en;
      return `
        <h3 style="margin:6px 0 10px;font-size:15px;border-top:1px solid #eee;padding-top:14px">${this.t('billing_title')}</h3>
        <div class="sw-quote-row full">
          <div class="sw-quote-field"><label>${this.t('billing_company')}</label>
            <input data-billing="company" value="${this.esc(b.company||'')}"></div>
        </div>
        <div class="sw-quote-row full">
          <div class="sw-quote-field"><label>${this.t('address')} <span class="req">*</span></label>
            <input data-billing="address" value="${this.esc(b.address||'')}"></div>
        </div>
        <div class="sw-quote-row">
          <div class="sw-quote-field"><label>${this.t('postal')} <span class="req">*</span></label>
            <input data-billing="postal" value="${this.esc(b.postal||'')}"></div>
          <div class="sw-quote-field"><label>${this.t('city')} <span class="req">*</span></label>
            <input data-billing="city" value="${this.esc(b.city||'')}"></div>
        </div>
        <div class="sw-quote-row">
          <div class="sw-quote-field"><label>${this.t('state')}${STATE_REQUIRED_COUNTRIES.includes(b.country) ? ' <span class="req">*</span>' : ''}</label>
            <input data-billing="state" value="${this.esc(b.state||'')}"></div>
          <div class="sw-quote-field"><label>${this.t('country')} <span class="req">*</span></label>
            <select data-billing="country">
              <option value="">${this.t('country_select')}</option>
              ${countries.map(([code,name]) => code.startsWith('__')
                ? `<option disabled>${name}</option>`
                : `<option value="${code}" ${b.country===code?'selected':''}>${name}</option>`).join('')}
            </select></div>
        </div>`;
    },

    renderStep3() {
      const c = this.contact, i = this.install;
      const productsHtml = this.products.map(p => `
        <div style="padding:10px 0;border-bottom:1px solid #eee;font-size:13.5px">
          <strong>${this.esc(p.title)}</strong> — ${this.esc(p.variant_title)}
          <div style="color:#666;font-size:12px;margin-top:2px">${this.t('qty')}: ${p.qty} · SKU: ${this.esc(p.sku||'-')}</div>
        </div>`).join('');
      return `
        <h3 style="margin:0 0 14px;font-size:18px">${this.t('verify_title')}</h3>

        <div style="background:#f8f8f8;padding:16px 18px;border-radius:6px;margin-bottom:18px">
          <strong>${this.esc(c.first_name)} ${this.esc(c.last_name)}</strong><br>
          <span style="color:#555;font-size:13px">${this.esc(c.email)} · ${this.esc(c.phone)}</span><br>
          <span style="color:#555;font-size:13px">${this.esc(c.address)}, ${this.esc(c.postal)} ${this.esc(c.city)}, ${this.esc(c.country)}</span>
          ${c.bill_different && c.billing ? `<br><span style="color:#555;font-size:13px"><strong>${this.t('billing_title')}${this.locale === 'fr' ? '\u00a0:' : ':'}</strong> ${c.billing.company ? this.esc(c.billing.company) + ', ' : ''}${this.esc(c.billing.address||'')}, ${this.esc(c.billing.postal||'')} ${this.esc(c.billing.city||'')}, ${this.esc(c.billing.country||'')}</span>` : ''}
        </div>
        <div style="margin-bottom:18px">${productsHtml}</div>
        ${i.dimensions ? `<div style="background:#f8f8f8;padding:12px 14px;border-radius:5px;font-size:13px;margin-bottom:8px"><strong>${this.t('wall_dimensions')}:</strong> ${this.esc(i.dimensions)}</div>` : ''}
        ${i.wall_status ? `<div style="background:#f8f8f8;padding:12px 14px;border-radius:5px;font-size:13px;margin-bottom:8px"><strong>${this.t('wall_status')}:</strong> ${this.esc(i.wall_status)}</div>` : ''}
        ${this.photos.length ? `<div style="margin-top:8px;font-size:12px;color:#666">${this.photos.length} foto(s)</div>` : ''}
        <div id="sw-step3-error" class="sw-error" hidden></div>
      `;
    },

    renderSuccess() {
      return `
        <div class="sw-success">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>
          </svg>
          <h2 style="margin:0 0 8px">${this.t('success_title')}</h2>
          <p style="color:#666;margin:0;line-height:1.6">${this.t(String((window.Shopify && window.Shopify.country) || '').toUpperCase() === 'US' && this.locale === 'en' ? 'success_text_us' : 'success_text')}</p>
        </div>`;
    },

    renderFooter() {
      const ft = document.getElementById('sw-footer');
      if (this.step === 4) {
        ft.innerHTML = `<div></div><button class="sw-quote-btn primary" onclick="window.SWQuote.close()">OK</button>`;
        return;
      }
      const back = this.step > 1 ? `<button class="sw-quote-btn" onclick="window.SWQuote.goBack()">${this.t('back')}</button>` : '<div></div>';
      const nextDisabled = this.step === 1 && !this.products.length;
      const next = this.step < 3
        ? `<button class="sw-quote-btn primary" onclick="window.SWQuote.goNext()" ${nextDisabled ? 'disabled' : ''}>${this.t('next')}</button>`
        : `<button class="sw-quote-btn primary" id="sw-submit-btn" onclick="window.SWQuote.submit()">${this.t('submit')}</button>`;
      ft.innerHTML = back + next;
    },

    bindBody() {
      // Step 1: qty + remove
      document.querySelectorAll('.sw-product-card').forEach(el => {
        const vid = parseInt(el.dataset.vid);
        const qtyInp = el.querySelector('[data-action="qty"]');
        if (qtyInp) qtyInp.addEventListener('change', e => {
          const p = this.products.find(x => x.variant_id === vid);
          if (p) p.qty = Math.max(1, parseInt(e.target.value) || 1);
          this.saveStorage();
        });
        const rmBtn = el.querySelector('[data-action="remove"]');
        if (rmBtn) rmBtn.addEventListener('click', () => {
          this.products = this.products.filter(x => x.variant_id !== vid);
          this.saveStorage();
          if (!this.products.length) this.close();
          else this.render();
        });
      });
      // Step 2: contact + install fields
      document.querySelectorAll('[data-field]').forEach(el => {
        el.addEventListener('input', e => {
          this.contact[el.dataset.field] = el.value;
          this.saveStorage();
          if (el.dataset.field === 'country') this.updateStateRequired();
        });
        el.addEventListener('change', e => {
          this.contact[el.dataset.field] = el.value;
          this.saveStorage();
          if (el.dataset.field === 'country') this.updateStateRequired();
          // Postcode + huisnummer autofill (alleen NL voor nu)
          if ((el.dataset.field === 'postal' || el.dataset.field === 'address')
              && this.contact.country === 'NL'
              && this.contact.postal && this.contact.address) {
            this.lookupNLAddress();
          }
        });
        el.addEventListener('blur', e => {
          if ((el.dataset.field === 'postal' || el.dataset.field === 'address')
              && this.contact.country === 'NL'
              && this.contact.postal && this.contact.address) {
            this.lookupNLAddress();
          }
        });
      });
      this.updateStateRequired();
      const billSame = document.getElementById('sw-bill-same');
      if (billSame) billSame.addEventListener('change', () => {
        this.contact.bill_different = !billSame.checked;
        this.saveStorage();
        this.render();
      });
      document.querySelectorAll('[data-billing]').forEach(el => {
        const zet = () => {
          this.contact.billing = Object.assign({}, this.contact.billing || {}, { [el.dataset.billing]: el.value });
          this.saveStorage();
        };
        el.addEventListener('input', zet);
        el.addEventListener('change', zet);
        if (el.dataset.billing === 'country') el.addEventListener('change', () => this.render());   // provincie-sterretje
      });
      document.querySelectorAll('[data-install]').forEach(el => {
        el.addEventListener('input', e => {
          this.install[el.dataset.install] = el.value;
          this.saveStorage();
          // Toggle photos-required marker als wall_status wijzigt
          if (el.dataset.install === 'wall_status') {
            const mk = document.getElementById('sw-photos-req-mark');
            if (mk) mk.style.display = el.value.trim() ? 'inline' : 'none';
          }
          // Bij want_install Yes/No: re-render zodat install-velden in/uit komen
          if (el.dataset.install === 'want_install') {
            this.render();
          }
        });
      });
      // Walls list bindings
      this.bindWallsList();
      // Photos
      document.querySelectorAll('[data-photo-slot]').forEach(el => {
        el.addEventListener('change', e => this.handlePhoto(parseInt(el.dataset.photoSlot), e.target.files[0]));
      });
      document.querySelectorAll('[data-photo-idx]').forEach(el => {
        el.addEventListener('click', () => {
          const idx = parseInt(el.dataset.photoIdx);
          this.photos.splice(idx, 1);
          document.getElementById('sw-photos').innerHTML = this.renderPhotos();
          this.bindBody();
        });
      });
    },

    updateStateRequired() {
      const mark = document.getElementById('sw-state-req-mark');
      if (mark) mark.style.display = STATE_REQUIRED_COUNTRIES.includes(this.contact.country) ? 'inline' : 'none';
    },

    lookupNLAddress() {
      // Gebruik PDOK (Nederlands open data, geen API key nodig). Vult straat + plaats automatisch
      // op basis van postcode + huisnummer. Niet blokkerend — bij fout doet 'ie niets.
      const m = (this.contact.address || '').match(/(\d+[a-zA-Z]?)/);
      const huis = m ? m[1] : '';
      const pc = (this.contact.postal || '').replace(/\s+/g, '').toUpperCase();
      if (!pc || !huis) return;
      if (this._lastLookup === pc + huis) return;
      this._lastLookup = pc + huis;
      fetch(`https://api.pdok.nl/bzk/locatieserver/search/v3_1/free?q=${encodeURIComponent(pc + ' ' + huis)}&fl=*&rows=1`)
        .then(r => r.json()).then(d => {
          const doc = (d.response && d.response.docs && d.response.docs[0]) || null;
          if (!doc) return;
          // straat + huisnummer + plaats
          const street = doc.straatnaam || '';
          const huisnr = doc.huisnummer ? String(doc.huisnummer) + (doc.huisnummertoevoeging ? ' '+doc.huisnummertoevoeging : '') : huis;
          const city   = doc.woonplaatsnaam || '';
          if (street && !this.contact.address.toLowerCase().startsWith(street.toLowerCase())) {
            this.contact.address = `${street} ${huisnr}`;
            const inp = document.querySelector('[data-field="address"]');
            if (inp) inp.value = this.contact.address;
          }
          if (city && !this.contact.city) {
            this.contact.city = city;
            const inp = document.querySelector('[data-field="city"]');
            if (inp) inp.value = city;
          }
          this.saveStorage();
        })
        .catch(() => {});
    },

    renderWallsList() {
      const walls = this.install.walls || [];
      if (!walls.length) walls.push({ width: '', height: '' });
      this.install.walls = walls;
      return walls.map((w, idx) => `
        <div class="sw-wall-row" data-wall-idx="${idx}">
          <span class="label">${this.t('wall_label_prefix')} ${idx+1}</span>
          <input type="number" min="1" max="9999" step="any" placeholder="${this.wallPh('wall_width')}" data-wall-field="width"
                 value="${this.esc(w.width||'')}">
          <input type="number" min="1" max="9999" step="any" placeholder="${this.wallPh('wall_height')}" data-wall-field="height"
                 value="${this.esc(w.height||'')}">
          ${walls.length > 1
            ? `<button type="button" class="sw-wall-remove" data-wall-remove="${idx}" title="${this.t('wall_remove')}">×</button>`
            : '<span></span>'}
        </div>`).join('');
    },

    addWall() {
      this.install.walls = (this.install.walls || []);
      this.install.walls.push({ width: '', height: '' });
      this.saveStorage();
      this.refreshWallsList();
    },
    removeWall(idx) {
      this.install.walls = (this.install.walls || []).filter((_, i) => i !== idx);
      if (!this.install.walls.length) this.install.walls.push({ width: '', height: '' });
      this.saveStorage();
      this.refreshWallsList();
    },
    refreshWallsList() {
      const list = document.getElementById('sw-walls-list');
      if (list) {
        list.innerHTML = this.renderWallsList();
        this.bindWallsList();
      }
    },
    // Kevin 19-10-2026: cm/inch-keuze zoals de calculator (alleen op /en; /en-us vult altijd in inches).
    renderUnitToggle() {
      if (!this.unitToggle) return '';
      const u = this.install.unit === 'in' ? 'in' : 'cm';
      const knop = (v, lbl) => `<button type="button" class="sw-unit-btn${u === v ? ' is-active' : ''}" data-swq-unit="${v}" aria-pressed="${u === v}">${lbl}</button>`;
      return `<div class="sw-units" role="group" aria-label="Measurement units">${knop('cm', 'cm')}${knop('in', 'inch')}</div>`;
    },
    wallPh(key) {
      const t = this.t(key);
      return this.install.unit === 'in' ? t.replace('(cm)', '(in)') : t;
    },
    setUnit(u) {
      this.install.unit = u === 'in' ? 'in' : 'cm';
      this.saveStorage();
      document.querySelectorAll('[data-swq-unit]').forEach(b => {
        const aan = b.dataset.swqUnit === this.install.unit;
        b.classList.toggle('is-active', aan);
        b.setAttribute('aria-pressed', aan ? 'true' : 'false');
      });
      this.refreshWallsList();
    },
    _num(v) {   // zelfde lezing als de calculator (readNum): komma of punt, alleen cijfers
      let raw = String(v == null ? '' : v).replace(/[^\d.,]/g, '').replace(/,/g, '.');
      const d = raw.indexOf('.');
      if (d !== -1) raw = raw.slice(0, d + 1) + raw.slice(d + 1).replace(/\./g, '');
      const n = parseFloat(raw);
      return (isFinite(n) && n > 0) ? n : null;
    },
    _inchVan(cm) {
      const n = this._num(cm);
      return n == null ? '?' : String(Math.round(n / 2.54 * 10) / 10);
    },
    // Wanden zoals ze naar het dashboard gaan: altijd cm (afgerond zoals de calculator), bij inch-invoer met de inches
    // van de klant erbij. Een onleesbare maat gaat ongewijzigd mee, zodat het dashboard hem afwijst zoals voorheen.
    _wallsVoorVerzending() {
      const inch = this.install.unit === 'in';
      return (this.install.walls || []).filter(w => w.width && w.height).map(w => {
        if (!inch) return { width: w.width, height: w.height };
        const bi = this._num(w.width), hi = this._num(w.height);
        if (bi == null || hi == null) return { width: w.width, height: w.height };
        return { width: String(Math.round(bi * 2.54)), height: String(Math.round(hi * 2.54)),
                 unit: 'in', width_in: String(bi), height_in: String(hi) };
      });
    },
    bindWallsList() {
      document.querySelectorAll('[data-swq-unit]').forEach(el => {
        el.onclick = () => this.setUnit(el.dataset.swqUnit);
      });
      document.querySelectorAll('[data-wall-field]').forEach(el => {
        el.addEventListener('input', e => {
          const row = el.closest('[data-wall-idx]');
          const idx = parseInt(row.dataset.wallIdx);
          const f = el.dataset.wallField;
          this.install.walls[idx][f] = el.value;
          this.saveStorage();
        });
      });
      document.querySelectorAll('[data-wall-remove]').forEach(el => {
        el.addEventListener('click', () => this.removeWall(parseInt(el.dataset.wallRemove)));
      });
      const addBtn = document.getElementById('sw-wall-add');
      if (addBtn) addBtn.onclick = () => this.addWall();
    },

    handlePhoto(slot, file) {
      if (!file) return;
      if (file.size > 3 * 1024 * 1024) {
        const err = document.getElementById('sw-step2-error');
        if (err) { err.textContent = this.t('error_photo_size'); err.hidden = false; }
        return;
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        this.photos[slot] = { file: file, preview: e.target.result };
        this.photos = this.photos.filter(x => x);  // dichten
        document.getElementById('sw-photos').innerHTML = this.renderPhotos();
        this.bindBody();
      };
      reader.readAsDataURL(file);
    },

    addAnotherProduct() {
      this.saveStorage();
      this.close();
      // Optie 1: alert dat user terug kan komen
      // Optie 2: gewoon sluiten — user navigeert zelf
      // Doe gewoon close — products zijn opgeslagen, modal heropenen op ander
      // product zal de bestaande array bewaren + nieuw product toevoegen.
    },

    goBack() { if (this.step > 1) { this.step--; this.render(); } },

    goNext() {
      if (this.step === 1) {
        if (!this.products.length) return;
        this.step = 2; this.render(); return;
      }
      if (this.step === 2) {
        if (!this.validateStep2()) return;
        this.step = 3; this.render(); return;
      }
    },

    validateStep2() {
      const required = ['first_name','last_name','email','phone','address','postal','city','country'];
      if (STATE_REQUIRED_COUNTRIES.includes(this.contact.country)) required.push('state');
      const missing = required.filter(k => !this.contact[k] || !this.contact[k].trim());
      const errEl = document.getElementById('sw-step2-error');
      if (missing.length) {
        if (errEl) { errEl.textContent = this.t('error_required'); errEl.hidden = false; }
        return false;
      }
      if (!this.contact.email.includes('@') || !this.contact.email.includes('.')) {
        if (errEl) { errEl.textContent = this.t('error_email'); errEl.hidden = false; }
        return false;
      }
      if (this.contact.bill_different) {
        const b = this.contact.billing || {};
        const nodig = ['address','postal','city','country'].concat(STATE_REQUIRED_COUNTRIES.includes(b.country) ? ['state'] : []);
        if (nodig.some(k => !b[k] || !String(b[k]).trim())) {
          if (errEl) { errEl.textContent = this.t('error_required'); errEl.hidden = false; }
          return false;
        }
      }
      const requiresWall = this.products.some(p => p.requires_wall);
      const validWalls = (this.install.walls || []).filter(w => w.width && w.height);
      const isNL = this.locale === 'nl';
      const wantInstall = isNL && this.install.want_install === 'yes';
      // NL: "Wil je installatie?" moet expliciet ja/nee zijn beantwoord
      if (isNL && !this.install.want_install) {
        if (errEl) { errEl.textContent = this.t('error_required'); errEl.hidden = false; }
        return false;
      }
      // Walls: vereist als product de tag mural/meter/paneel/panelen/set heeft, of als install=yes
      if ((requiresWall || wantInstall) && validWalls.length === 0) {
        if (errEl) { errEl.textContent = this.t('error_walls_required'); errEl.hidden = false; }
        // Scroll naar walls-block zodat user 'm direct ziet
        const wList = document.getElementById('sw-walls-list');
        if (wList) wList.scrollIntoView({behavior:'smooth', block:'center'});
        return false;
      }
      // Install-extras (primer-vragen + foto's) alleen verplicht als want_install=yes
      if (wantInstall) {
        if (!this.install.wall_already_primed || !this.install.wall_we_prime) {
          if (errEl) { errEl.textContent = this.t('error_required'); errEl.hidden = false; }
          return false;
        }
        if (this.photos.length === 0) {
          if (errEl) { errEl.textContent = this.t('photos_required'); errEl.hidden = false; }
          return false;
        }
      }
      if (errEl) errEl.hidden = true;
      return true;
    },

    async enrichAddressBeforeSubmit() {
      // Vangt race met async autofill: zorg dat NL-adres een straatnaam heeft vóór verzenden.
      try {
        if (this.contact.country !== 'NL') return;
        const addr = (this.contact.address || '').trim();
        if (/[A-Za-z]{3,}/.test(addr)) return; // heeft al een straatnaam
        const m = addr.match(/(\d+[a-zA-Z]?)/);
        const huis = m ? m[1] : '';
        const pc = (this.contact.postal || '').replace(/\s+/g, '').toUpperCase();
        if (!pc || !huis) return;
        const r = await fetch(`https://api.pdok.nl/bzk/locatieserver/search/v3_1/free?q=${encodeURIComponent(pc + ' ' + huis)}&fl=*&rows=1`);
        const d = await r.json();
        const doc = (d.response && d.response.docs && d.response.docs[0]) || null;
        if (!doc) return;
        const street = doc.straatnaam || '';
        const huisnr = doc.huisnummer ? String(doc.huisnummer) + (doc.huisnummertoevoeging ? ' '+doc.huisnummertoevoeging : '') : huis;
        if (street) {
          this.contact.address = `${street} ${huisnr}`;
          const inp = document.querySelector('[data-field="address"]');
          if (inp) inp.value = this.contact.address;
        }
        if (doc.woonplaatsnaam && !this.contact.city) {
          this.contact.city = doc.woonplaatsnaam;
          const ci = document.querySelector('[data-field="city"]');
          if (ci) ci.value = doc.woonplaatsnaam;
        }
        this.saveStorage();
      } catch (e) {}
    },

    async submit() {
      const btn = document.getElementById('sw-submit-btn');
      if (btn) { btn.disabled = true; btn.textContent = '…'; }
      await this.enrichAddressBeforeSubmit();
      const fd = new FormData();
      const data = {
        locale: this.locale,
        first_name: this.contact.first_name,
        last_name: this.contact.last_name,
        email: this.contact.email,
        phone: this.contact.phone,
        address: this.contact.address,
        postal: this.contact.postal,
        city: this.contact.city,
        state: this.contact.state || '',
        country: this.contact.country,
        customer_notes: this.contact.customer_notes || '',
        products: this.products.map(p => ({
          product_id: p.product_id,
          variant_id: p.variant_id,
          sku: p.sku,
          title: p.title,
          variant_title: p.variant_title,
          qty: p.qty,
          original_price: p.original_price,
          currency: p.currency || '',
        })),
        // Walls als gestructureerde JSON ipv vrije tekst.
        // Bewaar 'm in installation_dimensions als compact format: "Wand 1: 450×250 cm; Wand 2: 200×280 cm"
        // Kevin 19-10-2026: zoals de calculator altijd cm met inches erachter: "Wand 1: 366×259 cm (144×102 in)"
        installation_dimensions: this._wallsVoorVerzending()
          .map((w, i) => `Wand ${i+1}: ${w.width}×${w.height} cm (${w.width_in || this._inchVan(w.width)}×${w.height_in || this._inchVan(w.height)} in)`)
          .join('; '),
        installation_walls_json: JSON.stringify(this._wallsVoorVerzending()),
        installation_wall_already_primed: this.install.wall_already_primed || '',
        installation_wall_we_prime: this.install.wall_we_prime || '',
      };
      if (this.contact.bill_different && this.contact.billing) {
        const b = this.contact.billing;
        data.billing = { company: b.company || '', address: b.address || '', postal: b.postal || '',
                         city: b.city || '', state: b.state || '', country: b.country || '' };
      }
      // Attributie (contract met dashboard: optioneel object, mag een offerte nooit blokkeren)
      try { data.attribution = this._attribution(); } catch(e) { console.error('[sw-quote] attributie overgeslagen', e); }
      const lead = this._leadValue();
      fd.append('data', JSON.stringify(data));
      this.photos.forEach((p, i) => { if (p && p.file) fd.append('photo'+i, p.file); });

      fetch(this.DASHBOARD, { method: 'POST', body: fd })
        .then(r => r.json())
        .then(d => {
          if (d.ok) {
            // Cleanup storage + show success
            sessionStorage.removeItem(this.STORAGE);
            this.products = []; this.contact = {}; this.install = {}; this.photos = [];
            this.step = 4;
            this.render();
            this._trackLead(lead);
          } else {
            const err = document.getElementById('sw-step3-error');
            if (err) { err.textContent = (d.error || this.t('error_submit')); err.hidden = false; }
            if (btn) { btn.disabled = false; btn.textContent = this.t('submit'); }
          }
        })
        .catch(e => {
          const err = document.getElementById('sw-step3-error');
          if (err) { err.textContent = this.t('error_submit'); err.hidden = false; }
          if (btn) { btn.disabled = false; btn.textContent = this.t('submit'); }
        });
    },

    // ── Attributie + lead-event (21-09-2026) ─────────────────────────────────────────────
    // Leest wat snippets/sw-tracking.liquid (4b) vastlegt: _sw_ft (first/last touch) en _sw_clk (klik-ids).
    // Klik-ids en ga_client_id gaan ALLEEN mee met marketing-consent; utm/landing/referrer zijn first-party operationeel.
    _cookie(n) {
      try { const m = document.cookie.match('(?:^|; )' + n + '=([^;]*)'); return m ? decodeURIComponent(m[1]) : ''; }
      catch(e) { console.error('[sw-quote] cookie niet leesbaar: ' + n, e); return ''; }
    },
    _preloadConsent() {
      try {
        if (window.Shopify && !window.Shopify.customerPrivacy && typeof window.Shopify.loadFeatures === 'function') {
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], err => {
            if (err) console.error('[sw-quote] consent-API laden mislukt', err);
          });
        }
      } catch(e) { console.error('[sw-quote] consent-API laden mislukt', e); }
    },
    _consent() {
      const out = { marketing: 'unknown', analytics: 'unknown' };
      try {
        const cp = (window.Shopify && window.Shopify.customerPrivacy) || null;
        if (cp && typeof cp.marketingAllowed === 'function') out.marketing = cp.marketingAllowed() ? 'granted' : 'denied';
        if (cp && typeof cp.analyticsProcessingAllowed === 'function') out.analytics = cp.analyticsProcessingAllowed() ? 'granted' : 'denied';
      } catch(e) { console.error('[sw-quote] consent-API niet leesbaar', e); }
      return out;
    },
    _firstTouch() {
      let ft = null;
      try { const raw = window.localStorage.getItem('_sw_ft'); if (raw) ft = JSON.parse(raw); }
      catch(e) { console.error('[sw-quote] first-touch (localStorage) niet leesbaar', e); }
      if (!ft) {
        try { const rawc = this._cookie('_sw_ft'); if (rawc) ft = JSON.parse(rawc); }
        catch(e) { console.error('[sw-quote] first-touch (cookie) niet leesbaar', e); }
      }
      return (ft && typeof ft === 'object') ? ft : {};
    },
    _attribution() {
      const a = {};
      const put = (k, v) => { if (typeof v !== 'string' && typeof v !== 'number') return; v = String(v).trim(); if (v) a[k] = v.slice(0, 500); };
      try {
        const c = this._consent();
        a.consent_marketing = c.marketing;
        a.consent_analytics = c.analytics;
        const ft = this._firstTouch();
        const first = (ft.first && typeof ft.first === 'object') ? ft.first : {};
        const last = (ft.last && typeof ft.last === 'object') ? ft.last : null;
        const camp = last || first;                       // utm = meest recente campagne-touch, anders de first-touch
        ['utm_source','utm_medium','utm_campaign','utm_term','utm_content'].forEach(k => put(k, camp[k]));
        put('landing_page', first.landing_page);
        put('referrer', first.referrer);
        put('first_seen', first.first_seen);
        if (last) { put('last_landing_page', last.landing_page); put('last_referrer', last.referrer); put('last_seen', last.seen); }
        if (c.marketing === 'granted') {
          let clk = {};
          try { clk = JSON.parse(this._cookie('_sw_clk') || '{}') || {}; }
          catch(e) { console.error('[sw-quote] _sw_clk niet leesbaar', e); clk = {}; }
          ['gclid','gbraid','wbraid','fbclid','msclkid'].forEach(k => put(k, clk[k]));
          const ga = this._cookie('_ga');                 // GA1.1.<client_id deel 1>.<deel 2>
          if (ga) { const p = ga.split('.'); if (p.length >= 4) put('ga_client_id', p.slice(-2).join('.')); }
        }
        let loc = this.locale;
        try { if (window.Shopify && window.Shopify.locale) loc = window.Shopify.locale + (window.Shopify.country ? '-' + window.Shopify.country : ''); }
        catch(e) { console.error('[sw-quote] locale niet leesbaar', e); }
        put('locale', loc);
      } catch(e) { console.error('[sw-quote] attributie opbouwen mislukt', e); }
      return a;
    },
    // Offertetotaal alleen als het ECHT bekend is: elk product een prijs > 0, geen wand-afhankelijk product, valuta bekend.
    _leadValue() {
      try {
        const cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
        if (!cur || !this.products.length) return {};
        let total = 0;
        for (const p of this.products) {
          const pr = Number(p.original_price), q = Math.min(999, Math.max(1, Number(p.qty) || 1));
          if (!(pr > 0) || p.requires_wall || !p.currency || p.currency !== cur) return {};   // valuta onbekend of gemengd (product op /en-us toegevoegd, offerte vanaf /en) → geen bedrag
          total += pr * q;
        }
        return total > 0 ? { value: Math.round(total * 100) / 100, currency: String(cur) } : {};
      } catch(e) { console.error('[sw-quote] offertetotaal onbekend', e); return {}; }
    },
    // GA4-lead-event zonder persoonsgegevens; Consent Mode v2 (sw-tracking) bepaalt wat Google ermee mag.
    _trackLead(lead) {
      try {
        const v = (lead && lead.value > 0) ? lead.value : undefined;
        const cur = (v !== undefined && lead.currency) ? lead.currency : undefined;
        // Eén afleverpad: het gtag-commando (de Google-tag die GTM laadt verwerkt het). Een losse dataLayer-push ernaast zou dubbel
        // tellen zodra iemand een GTM-trigger op generate_lead zet. Zonder window.gtag: hetzelfde commando op de dataLayer (standaard gtag-stub).
        window.dataLayer = window.dataLayer || [];
        const g = (typeof window.gtag === 'function') ? window.gtag : function(){ window.dataLayer.push(arguments); };
        g('event', 'generate_lead', { lead_type: 'quote', value: v, currency: cur });
      } catch(e) { console.error('[sw-quote] generate_lead niet verstuurd', e); }
    },

    esc(s) { return String(s||'').replace(/[&<>"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c])); },
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => SW.init());
  else SW.init();
})();
